import axiosInstance from "@/utils/axiosInstance";

const baseUrl = `api/lots`;

const state = {};

const getters = {};

const mutations = {};

const actions = {
  read({commit}, payload) {
    return axiosInstance.get(baseUrl, {params: payload})
      .then((data) => data.data);
  },
};
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
